import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalCloseButton,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';
import { useCompleteTicketModal } from './use-complete-ticket-modal';

export type TCompleteTicketModalType = 'CompleteTicketModal';
export interface ICompleteTicketModalProps {
  spaceId: string;
  ticketId: string;
  onSuccess?: () => Promise<void> | void;
}

const CompleteTicketModal = memo(({ spaceId, ticketId, onSuccess }: ICompleteTicketModalProps) => {
  const {
    // FORM
    form,
    isOpen,
    isDisabledForm,
    isLoadingForm,

    // HANDLERS
    handleCancelModal,
    handleCloseModal,
    handleSubmitForm,
  } = useCompleteTicketModal({
    spaceId,
    ticketId,
    onSuccess,
  });

  // RENDER
  return (
    <Modal
      isOpen={isOpen}
      lockBodyScroll
      onClose={handleCloseModal}
      isCloseOutside={false}
      className="md:w-[500px] w-[345px] p-[24px]"
    >
      <ModalHeader>
        <ModalTitle>Are you sure you want to complete this ticket?</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="complete-ticketing-ticket-form"
          className="grid gap-[16px] mt-[16px]"
        >
          <span className="text-[14px] font-normal text-[#9D9D9C]">
            Once you complete this ticket, it <span className="font-[700]">can't be changed anymore</span>. You can only
            do this once. After that, an email will be sent to the ticket creator and anyone mentioned in the ticket.
          </span>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleCancelModal();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="complete-ticketing-ticket-form" type="submit" disabled={isDisabledForm}>
          {isLoadingForm ? <Spinner isLoading={true} className="w-[18px] h-[18px]" /> : null} Okay
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
CompleteTicketModal.displayName = 'CompleteTicketModal';
export default CompleteTicketModal;
